import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseCarouselSlide from './HseCarouselSlide.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseCarouselSlide;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hse-CarouselSlide swiper-slide"},[_vm._t("default",[(_vm.image)?_c('div',{staticClass:"hse-CarouselSlide__image",class:_vm.classes.image,style:({
        backgroundImage: ("url('" + _vm.image + "')")
      })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hse-CarouselSlide__content grid",class:_vm.classes.content},[(_vm.title || _vm.$slots.title)?_c('div',{staticClass:"hse-CarouselSlide__title col-mobile-small-4 col-mobile-large-4 col-tablet-small-8 col-tablet-large-12 col-desktop-small-10 col-desktop-medium-10 col-desktop-large-10",class:_vm.classes.title},[_vm._t("title",[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")])],2):_vm._e(),_vm._v(" "),(_vm.description || _vm.$slots.description)?_c('div',{staticClass:"hse-CarouselSlide__description col-mobile-small-4 col-mobile-large-4 col-tablet-small-8 col-tablet-large-12 col-desktop-small-10 col-desktop-medium-10 col-desktop-large-10",class:_vm.classes.description},[_vm._t("description",[_vm._v("\n          "+_vm._s(_vm.description)+"\n        ")])],2):_vm._e()])])],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
